import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'EXPORT_LICENSE',
    icon: 'menu-export-license',
    label: '出口许可证',
    path: '/export-license',
  },
] satisfies Menu[];
